import { render, staticRenderFns } from "./AccountConfigEmails.vue?vue&type=template&id=25691aee"
import script from "./AccountConfigEmails.vue?vue&type=script&lang=js"
export * from "./AccountConfigEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports